import { MainView, DownloadDetailsContent } from './interfaces.js';
import { DownloadDetails } from './download-details.js';
import { ErrorDetails } from './error-details.js';
import { PassphraseForm } from './passphrase-form.js';
import { PassphraseHandler } from './passphrase-handler.js';

export type MainAppOptions = {
  salt: string;

  form: HTMLFormElement;
  passphraseInput: HTMLInputElement;
  passphraseList: HTMLElement;
  resetButton: HTMLButtonElement;

  downloadDetails: HTMLElement;
  downloadFilename: HTMLSpanElement;
  downloadSize: HTMLSpanElement;
  downloadType: HTMLSpanElement;
  downloadButton: HTMLButtonElement;

  errorDetails: HTMLElement;
  errorMessage: HTMLSpanElement;
  errorResetButton: HTMLButtonElement;
};

export class MainApp implements MainView {
  private readonly passphraseForm: PassphraseForm;
  private readonly downloadDetails: DownloadDetails;
  private readonly errorDetails: ErrorDetails;
  readonly salt: string;
  get apiClient() {
    return this.passphraseHandler.apiClient;
  }

  constructor(input: MainAppOptions, readonly passphraseHandler: PassphraseHandler) {
    this.salt = input.salt;
    this.passphraseForm = new PassphraseForm(
      input.form,
      input.passphraseInput,
      input.passphraseList,
      input.resetButton,
      this,
    );
    this.downloadDetails = new DownloadDetails(
      input.downloadDetails,
      input.downloadFilename,
      input.downloadSize,
      input.downloadType,
      input.downloadButton,
    );
    this.errorDetails = new ErrorDetails(
      input.errorDetails,
      input.errorMessage,
      input.errorResetButton,
      this,
    );
  }

  showPassphraseForm(): void {
    this.passphraseForm.show();
    this.downloadDetails.hide();
    this.errorDetails.hide();
  }

  resetPassphraseForm(): void {
    this.passphraseForm.resetForm();
  }

  showDownloadDetails(content: DownloadDetailsContent): void {
    this.downloadDetails.setContent(content);
    this.downloadDetails.show();
    this.passphraseForm.hide();
    this.errorDetails.hide();
  }

  showErrorDetails(message: string, { disableReset }: {
    disableReset: boolean;
  } = { disableReset: false }): void {
    this.errorDetails.setErrorMessage(message);
    if (disableReset) {
      this.errorDetails.disableResetButton();
    }
    this.errorDetails.show();
    this.passphraseForm.hide();
    this.downloadDetails.hide();
  }
}
